import { useUnit } from 'effector-react'
import React from 'react'

import * as googleModel from '@/shared/lib/google-login/model'

import { hideGoogleOneTap, showGoogleOneTap } from './lib'

export function useGoogleOneTap(enabled: boolean) {
    const initialized = useUnit(googleModel.$googleInitialized)

    React.useEffect(() => {
        if (!initialized || !enabled) {
            return
        }

        showGoogleOneTap()

        return () => {
            hideGoogleOneTap()
        }
    }, [enabled, initialized])
}
